module.exports = __webpack_public_path__ + "media/logos/google-logo-standalone-e326c92d.png";